var _a;
import * as React from 'react';
import CahtFilledSmall from 'wix-ui-icons-common/CahtFilledSmall';
import WixChatFilledSmall from 'wix-ui-icons-common/WixChatFilledSmall';
import FacebookSmall from 'wix-ui-icons-common/FacebookSmall';
import InstagramSmall from 'wix-ui-icons-common/InstagramSmall';
import EmailFilledSmall from 'wix-ui-icons-common/EmailFilledSmall';
import WixFormsFilledSmall from 'wix-ui-icons-common/WixFormsFilledSmall';
import PhoneFilledSmall from 'wix-ui-icons-common/PhoneFilledSmall';
import { deliveryMethodIcons } from '../../constants/delivery-method-icons';
import { DeliveryMethodId } from '@wix/chat-sdk';
export var messageIcons = (_a = {},
    _a[deliveryMethodIcons[DeliveryMethodId.SMS]] = React.createElement(CahtFilledSmall, null),
    _a[deliveryMethodIcons[DeliveryMethodId.Chat]] = React.createElement(WixChatFilledSmall, null),
    _a[deliveryMethodIcons[DeliveryMethodId.Email]] = React.createElement(EmailFilledSmall, null),
    _a[deliveryMethodIcons[DeliveryMethodId.Facebook]] = React.createElement(FacebookSmall, null),
    _a[deliveryMethodIcons[DeliveryMethodId.Instagram]] = React.createElement(InstagramSmall, null),
    _a['virtual-number.sms.icon'] = React.createElement(CahtFilledSmall, null),
    _a['virtual-number.voice.icon'] = React.createElement(PhoneFilledSmall, null),
    _a['virtual-number.recording.icon'] = React.createElement(PhoneFilledSmall, null),
    _a['contact.contact.form.icon'] = React.createElement(WixFormsFilledSmall, null),
    _a['contact.phone.call.icon'] = React.createElement(PhoneFilledSmall, null),
    _a);
//# sourceMappingURL=MessageIcons.js.map